module.exports = __webpack_public_path__ + "static/img/gp-icon2.7a8792b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/gp-icon2.png
// module id = 1
// module chunks = 0